import styled, { keyframes, css } from 'styled-components'
import './wsh.css'

export const wshColors = {
  primary:      '#003366',
  primaryDark:  '#1A2128',
  primaryLight: '#004d99',
  accent:       '#00A676',
  accentDark:   '#005f43',
  accentLight:  '#00C48B',
} as const

// ─── Animations ───────────────────────────────────────────────────────────────

export const wobble = keyframes`
  0%   { transform: rotate(0deg) scale(1); }
  15%  { transform: rotate(-12deg) scale(1.12); }
  30%  { transform: rotate(9deg) scale(1.08); }
  45%  { transform: rotate(-6deg) scale(1.05); }
  60%  { transform: rotate(4deg) scale(1.02); }
  75%  { transform: rotate(-2deg) scale(1.01); }
  100% { transform: rotate(0deg) scale(1); }
`

export const buttonPulse = keyframes`
  0%   { box-shadow: 0 4px 16px rgba(0, 51, 102, 0.35), 0 0 0 0px rgba(0, 80, 143, 0.3); }
  50%  { box-shadow: 0 4px 24px rgba(0, 51, 102, 0.5), 0 0 0 10px rgba(0, 80, 143, 0); }
  100% { box-shadow: 0 4px 16px rgba(0, 51, 102, 0.35), 0 0 0 0px rgba(0, 80, 143, 0); }
`

export const textFadeIn = keyframes`
  0%   { opacity: 0; }
  100% { opacity: 1; }
`

// ─── Trigger ──────────────────────────────────────────────────────────────────

export const TriggerWrapper = styled.div`
  position: fixed;
  bottom: 1.75rem;
  right: 1.75rem;
  z-index: 1040;
`

export const TriggerButton = styled.button<{ $expanded: boolean }>`
  position: relative;
  height: 52px;
  width: ${p => p.$expanded ? '220px' : '52px'};
  border-radius: 999px;
  border: none;
  background: ${wshColors.primary};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 51, 102, 0.35);
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), background 0.15s;
  flex-shrink: 0;
  padding: 0;
  overflow: hidden;

  animation: ${css`${buttonPulse} 2.5s ease-in-out infinite`};

  &:hover {
    background: ${wshColors.primaryLight};
    box-shadow: 0 6px 20px rgba(0, 51, 102, 0.45);
    width: 220px;
  }

  &:focus { outline: none; }
  &:focus-visible { outline: 2px solid ${wshColors.accent}; }
`

export const TriggerLogoWrap = styled.div`
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const TriggerLogoIcon = styled.img<{ $animating: boolean }>`
  width: 34px;
  height: auto;
  filter: brightness(1.3);
  pointer-events: none;
  animation: ${p => p.$animating ? css`${wobble} 0.7s ease forwards` : 'none'};
`

export const TriggerLabelText = styled.span`
  font-size: 0.78rem;
  font-weight: 700;
  color: white;
  white-space: nowrap;
  padding-right: 1rem;
  letter-spacing: 0.01em;
  animation: ${css`${textFadeIn} 0.3s ease 0.2s both`};
`

// ─── Modal Tour Trigger ───────────────────────────────────────────────────────

export const ModalTourTriggerWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  background: white;
  border-top: 1px solid #e5e7eb;
`
